import { useEffect } from 'react';
import { useUiStore } from '../../core/stores/uiStore.js';

const styles = {
  success: 'bg-white text-success border-l-success',
  error: 'bg-white text-danger border-l-danger',
  info: 'bg-white text-brand border-l-brand',
  warning: 'bg-white text-yellow-700 border-l-yellow-500',
};

export function ToastContainer() {
  const toasts = useUiStore((s) => s.toasts);
  const removeToast = useUiStore((s) => s.removeToast);

  return (
    <div className="fixed top-4 left-4 right-4 z-[100] flex flex-col gap-2 pointer-events-none">
      {toasts.map((toast) => (
        <ToastItem key={toast.id} toast={toast} onDismiss={() => removeToast(toast.id)} />
      ))}
    </div>
  );
}

function ToastItem({ toast, onDismiss }) {
  useEffect(() => {
    const timer = setTimeout(onDismiss, 4000);
    return () => clearTimeout(timer);
  }, [onDismiss]);

  return (
    <div
      className={`pointer-events-auto animate-[toast-slide-in_0.3s_ease-out] rounded-xl border-l-4 px-4 py-3 shadow-[var(--shadow-lg)] ${styles[toast.type] || styles.info}`}
      role="alert"
    >
      {toast.message}
    </div>
  );
}
